import { Icons } from '@/components/Shares/Icons';
import classes from '@/components/Shares/Table.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { ActionIcon, Avatar, Group, NumberFormatter, Table, Text } from '@mantine/core';
import { transactionRows } from './transactionRows';
export const TransactionTable: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  const rows = transactionRows.map(row => <Table.Tr key={row.id}>
      <Table.Td miw={80}>
        <Text fz={{
        base: 'xs',
        md: 13
      }} c="var(--text-dark)">
          {row.date}
        </Text>
      </Table.Td>
      <Table.Td visibleFrom="sm">
        <Text tt="capitalize" fz={{
        base: 'xs',
        md: 13
      }} c="var(--text-dark)">
          {row.type}
        </Text>
      </Table.Td>
      <Table.Td miw={80}>
        <Group wrap="nowrap" gap={10}>
          <Avatar src={row.currency.coinImg} alt="coin" size={32} />
          <Text fz={{
          base: 'xs',
          md: 13
        }} c="var(--text-dark)">
            {row.currency.coinName}
          </Text>
        </Group>
      </Table.Td>
      <Table.Td miw={90}>
        <Text fw={700} fz={{
        base: 'xs',
        md: 13
      }} c={row.amount < 0 ? 'prime.15' : 'var(--text-green)'}>
          <NumberFormatter prefix={row.type === 'deposit' ? '+$' : '$'} value={row.amount} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale />
        </Text>
      </Table.Td>
      <Table.Td>
        <Group>
          <ActionIcon variant="transparent" ml="auto" onClick={() => setOpenModal(MODAL.TRANSACTION_DETAIL)}>
            <Icons className="icon-pr-line-eye" color="var(--icon-color)" fontSize={20} />
          </ActionIcon>
        </Group>
      </Table.Td>
    </Table.Tr>);
  const ths = <Table.Tr>
      <Table.Th fz={{
      base: 10,
      md: 12
    }} w={{
      base: 230,
      md: 300
    }}>
        {i18n._('DATE')}
      </Table.Th>
      <Table.Th visibleFrom="sm" fz={{
      base: 10,
      md: 12
    }}>
        {i18n._('TYPE')}
      </Table.Th>
      <Table.Th fz={{
      base: 10,
      md: 12
    }}>{i18n._('CURRENT')}</Table.Th>
      <Table.Th fz={{
      base: 10,
      md: 12
    }}>{i18n._('AMOUNT')}</Table.Th>
      <Table.Th fz={{
      base: 10,
      md: 12
    }}>{''}</Table.Th>
    </Table.Tr>;
  return <Table.ScrollContainer minWidth={300}>
      <Table striped classNames={classes}>
        <Table.Thead>{ths}</Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </Table.ScrollContainer>;
};